module.exports = __webpack_public_path__ + "img/DX640_ZOOM.d60ccae.jpg";